/*
 * Purpose : common button component for approvals
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React from 'react'
import { colors } from "../../../styleConstants";
import { Col, Row } from 'reactstrap'
import ToolSalesButton from '../../UI/Buttons/ToolSalesButton/ToolSalesButton'

const ApprovalButton = (props) => {
    return (
        <>
          <div style={{ textAlign: "left", marginLeft: "2%", marginRight: "2%" }}>
              <Row form style={{ justifyContent: "flex-end" }}>            
                <Col md="auto">
                  <ToolSalesButton  style={{backgroundColor: colors.successColor}}  onClick={() => props.setModal(true)} >
                  {props.text}
                  </ToolSalesButton>
                </Col>
                <Col md="auto">
                  <ToolSalesButton style={{backgroundColor: colors.dangerColor}} onClick={()=> props.setRejectModal(true)}
                  >Reject</ToolSalesButton>
                </Col>
              </Row>
            </div>  
        </>
    )
}

export default ApprovalButton
